module.exports = __webpack_public_path__ + "images/a30bebfe09d05855ee1a9e793b1c1e11-illu_resolution_garageDoor_tilt.png";